import PeriodStart from "./period-start";

export default class IndoorPeriodStart extends PeriodStart {
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        await super.apply(gameContext, ruleContext, eventConfiguration, {
            play,
            fragment
        });

        // Indoor football keeps sides across halftime: teams swap only
        // between Q1/Q2 and Q3/Q4
        if (gameContext.isStartOfSecondHalf(fragment.period)) {
            gameContext.triggerSwapTeams = false;
        }
    }
}
